import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {DateRangeTimeFiltersService} from "../../services/date-range-time-filters.service";

export class BringozCustomizedTableColumnsSettingsComponent implements IController {
  columns: any;
  title?: string;
  isOpen: boolean;
  columnsTranslationPrefix: string;
  onToggleIsOpen: Function;
  onColumnsChange: Function;

  constructor() {
  }

  $onInit() {

  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozCustomizedTableColumnsSettings', {
    bindings: {
      columns: '<',
      title : '@?',
      isOpen : '<?',
      columnsTranslationPrefix: '@?',
      onToggleIsOpen: '&',
      onColumnsChange: '&'
    },
    template: require('./bringoz-customized-table-columns-settings.html').default,
    controller: BringozCustomizedTableColumnsSettingsComponent
  });
